import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';

import * as actions from '../actions';
import * as actionTypes from '../actionTypes';
import * as reducer from './reducer';
import Notifications from '../lib/Notifications';
import toJS from './toJS';

const Notify = ({dispatch, notifications}) => {
	const onRemove = uid => {
		dispatch(actions.hide(uid));
	};

	return (
		<Notifications
			onRemove={onRemove}
			notifications={notifications}
		/>
	);
};

const NotifyService = connect(
	state => ({notifications: state.get('notifications')}),
	dispatch => ({dispatch}))(toJS(Notify)
);

Notify.propTypes = {
	dispatch: PropTypes.func,
	notifications: PropTypes.array,
};

export {actions, actionTypes, reducer, NotifyService};



// WEBPACK FOOTER //
// ./src/common/notify/immutable/index.js